import React from 'react';
import './OurPartners.css';

const partnersData = [
  {
    title: 'Highlights',
    name: 'Pharo Foundation',
    image: '/image/pharo.png',
    link: 'https://www.pharofoundation.org/harnessing-ai-powered-computer-vision-remotely-monitor-access-water-somaliland',
  },
  {
    title: 'Highlights',
    name: 'NCBA Bank',
    image: '/image/ncba.png',
    link: 'https://play.google.com/store/apps/details?id=mobile.cbagroup.com.CBAMobile.UgandaApp&hl=en&pli=1',
  },
  {
    title: 'Highlights',
    name: 'NVIDIA',
    image: '/image/nvidia.png',
    link: 'https://developer.nvidia.com/embedded/jetson-modules',
  },
  {
    title: 'Highlights',
    name: 'Roboflow',
    image: '/image/roboflow.png',
    link: 'https://roboflow.com/industries',
  },
];

const OurPartners = () => {
  return (
    <div className="our-partners-section">
      <h2 className="partners-title">Our Partners</h2>
      <div className="partners-cards-container">
        {partnersData.map((partner, index) => (
          <div key={index} className="partner-card">
            <div className="card-image">
              <img src={partner.image} alt={partner.name} />
            </div>
            <div className="card-info">
              {/* Updated CSS handles hover behavior */}
              <a
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-title"
              >
                {partner.title}
                <span className="hover-text">Follow Link</span>
              </a>
              <p className="partner-description">{partner.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurPartners;
